module.exports = __webpack_public_path__ + "static/media/SM.9ad5741f.webp";